// extracted by mini-css-extract-plugin
export default {"contactBlock":"Contact_contactBlock__b0InN","form":"Contact_form__NJfuW","contact_textBlock":"Contact_contact_textBlock__gfFna","informText":"Contact_informText__bChfn"};